import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import css from './patientCard.css'

const RelatedPatients = ({ relatedPatients }) => (
  <div className={css.relatedPatients}>
    <div className={css.horizontalLine} />
    <span className={css.label}>
      Related Patients
    </span>
    <ul className={css.list}>
      {relatedPatients.map(rp => (
        <li className={css.relatedPatient} key={rp.id}>
          <Link to={`/patients/${rp.id}`}>{rp.first_name} {rp.last_name}</Link>
        </li>
      ),
    )}
    </ul>
  </div>
)

export default RelatedPatients



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/RelatedPatients.js